import { apiClient } from '@store/index';
import { axiosErrorMiddleware } from '../common';
import { QueryFunctionContext } from '@tanstack/react-query';
import { IntegrationSecret, IntegrationSecretCreateRequest } from './secrets.types';

export const getSecrets = async ({
  queryKey,
}: QueryFunctionContext<[string, { serviceId: string | undefined }]>): Promise<IntegrationSecret[]> => {
  const [, { serviceId }] = queryKey;

  const response = await apiClient.get<IntegrationSecret[]>(`/${serviceId}/secrets`);
  return response.data.sort((a, b) => a.type.localeCompare(b.type));
};

export const createSecret = async (data: {
  serviceId: string;
  secret: IntegrationSecretCreateRequest<'basic' | 'bearer'>;
}): Promise<IntegrationSecret> => {
  const { serviceId, secret } = data;

  try {
    const response = await apiClient.post<IntegrationSecret>(`/${serviceId}/secrets`, secret);
    return response.data;
  } catch (error) {
    throw new Error(axiosErrorMiddleware(error).error);
  }
};

export const deleteSecret = async ({ serviceId, secretId }: { serviceId: string; secretId: string }) => {
  try {
    const response = await apiClient.delete<{ success: true }>(`/${serviceId}/secrets?secret_id=${secretId}`);
    return response.data;
  } catch (error) {
    throw new Error(axiosErrorMiddleware(error).error);
  }
};
